export var UsersTeamsPageTabIds;
(function (UsersTeamsPageTabIds) {
    UsersTeamsPageTabIds["users"] = "users";
    UsersTeamsPageTabIds["invites"] = "invites";
    UsersTeamsPageTabIds["teams"] = "teams";
})(UsersTeamsPageTabIds || (UsersTeamsPageTabIds = {}));
